(() => {
  if (window.FourPawCartCopy) return;

  const apply = (root = document) => {
    const settings = window.FourPawCartCopySettings || {};
    const replacementCopy = [settings.freeShippingDetail, settings.guaranteeDetail];
    root.querySelectorAll('.fp-cart-reference-benefit__copy small').forEach((element, index) => {
      const copy = replacementCopy[index];
      if (copy && element.textContent.trim() !== copy) element.textContent = copy;
    });
  };

  let frame = 0;
  const schedule = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => apply());
  };

  const start = () => {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:block:select', schedule);

  window.FourPawCartCopy = { apply };
})();
